module.exports = __webpack_public_path__ + "img/closeapp_popup picture.e9d02f1d.png";